import { RouteConfig } from 'packages/route'
import { lazy } from 'react'

export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/studentManagement',
    name: 'AdminStudentManagement',
    getTitle: () => '学生管理',
    component: lazy(() =>
      import('./pages/index').then((m) => ({
        default: m.StudentManagement,
      }))
    ),
    subRoutes: [
      {
        path: 'internalStudents',
        getTitle: () => '在校学生',
        component: lazy(() =>
          import('./pages/internalStudents/InternalList').then((m) => ({
            default: m.InternalList,
          }))
        ),
      },
      {
        path: 'outgoingStudents',
        getTitle: () => '离校学生',
        component: lazy(() =>
          import('./pages/outgoingStudents/OutgoingList').then((m) => ({
            default: m.OutgoingList,
          }))
        ),
      },
    ],
  },
  {
    path: 'admin/studentManagement/internalStudents/details/:id',
    name: 'AdminInternalDetail',
    getTitle: () => '学生详情',
    component: lazy(() =>
      import('./pages/components/Detail').then((m) => ({
        default: m.Detail,
      }))
    ),
  },
  {
    path: 'admin/studentManagement/internalStudents/add-student',
    name: 'AddInternalStudent',
    getTitle: () => '新增学生',
    component: lazy(() =>
      import('./pages/components/AddStudent').then((m) => ({
        default: m.AddStudent,
      }))
    ),
  },
  {
    path: 'admin/studentManagement/internalStudents/fields-management',
    name: 'InternalStudentsFieldSetting',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/components/FieldSetting').then((m) => ({
        default: m.FieldSetting,
      }))
    ),
  },
  {
    path: 'admin/studentManagement/outgoingStudents/details/:id',
    name: 'AdminOutgoingDetail',
    getTitle: () => '学生详情',
    component: lazy(() =>
      import('./pages/components/Detail').then((m) => ({
        default: m.Detail,
      }))
    ),
  },
  {
    path: 'admin/studentManagement/outgoingStudents/fields-management',
    name: 'OutgoingStudentsFieldSetting',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/components/FieldSetting').then((m) => ({
        default: m.FieldSetting,
      }))
    ),
  },
]
